// actions/authActions.js (create this file if you don't have)

import { persistor } from "../store";

export const logout = () => (dispatch) => {
  persistor.purge(); // clears redux-persist storage (localStorage)
  dispatch({ type: "LOGOUT" });
};
